import { Stack } from 'expo-router'
import { useIsBenefitScreenPresentedAsModal } from '@/src/experiences/card-benefits/components/BenefitModal'
import type { NativeStackNavigationOptions } from '@react-navigation/native-stack'

type ExpoStackProps = React.ComponentProps<typeof Stack>

export function Layout({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) {
  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()

  const modalableBenefitScreenOptions = {
    animation: 'default',
    ...(isBenefitScreenPresentedAsModal ? { presentation: 'transparentModal' } : undefined),
  } satisfies NativeStackNavigationOptions | undefined

  return (
    <Stack {...ExpoStackProps} screenOptions={{ headerShown: false, animation: 'none' }}>
      <Stack.Screen name="benefits" />
      <Stack.Screen name="benefit" options={modalableBenefitScreenOptions} />
      <Stack.Screen name="my-lowes-rewards" options={modalableBenefitScreenOptions} />
      <Stack.Screen name="referral-bonus-offer" options={modalableBenefitScreenOptions} />
      <Stack.Screen name="my-lowes-reward-webview" options={modalableBenefitScreenOptions} />
      <Stack.Screen name="instacart-enrollment" options={modalableBenefitScreenOptions} />
    </Stack>
  )
}
